import type { FC } from "react";

import { Popover } from "@heroui/react";

type Props = {
  children: React.ReactNode;
  isOpen?: boolean;
  onOpenChange?: () => void;
  offset?: number;
};
export const PopoverRoot: FC<Props> = ({
  children,
  isOpen,
  onOpenChange,
  offset = -4,
}) => {
  return (
    <>
      <Popover
        placement="bottom-start"
        offset={offset}
        containerPadding={0}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
      >
        {children}
        <></>
      </Popover>
    </>
  );
};
